import clsx from 'clsx'
import React from 'react'
import FlagIcon from '../../../icons/FlagIcon'
import Notepad from '../../../icons/Notepad'
import StarFilled from '../../../icons/StarFilled'
import styles from './styles.module.css' // assuming you renamed the file correctly

const colors = [
  {
    label: 'Online',
    color: 'calendar-legend--online'
  },
  {
    label: 'Live Online',
    color: 'calendar-legend--live-online'
  },
  {
    label: 'Offline',
    color: 'calendar-legend--offline'
  },
  {
    label: 'Cancelled',
    color: 'calendar-legend--cancel'
  },
  {
    label: 'Holiday',
    color: 'calendar-legend--holiday'
  }
]
const CalendarLegend = () => {
  return (
    <div className={styles['calendar-legend']}>
      {colors.map(({ label, color }) => (
        <div className={styles['calendar-legend--container']} key={color}>
          <div
            className={clsx(styles['calendar-legend__dot'], styles[color])}
          />
          <span>{label}</span>
        </div>
      ))}
      <div className={styles['calendar-legend--container']}>
        <StarFilled />
        <span>Case Study</span>
      </div>
      <div className={styles['calendar-legend--container']}>
        <Notepad />
        <span>Test</span>
      </div>
      <div className={styles['calendar-legend--container']}>
        <FlagIcon />
        <span>Key Content</span>
      </div>
    </div>
  )
}

export default CalendarLegend
